module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-9.01f85491.JPG";